import * as z from "zod";

const schema = z.object({
    list: z.record(z.string(), z.array(z.object({
        areaBlockId: z.number(),
        codeDetail: z.string()
    })))
});

const model = schema.transform((values) => ({
    ...values
}));

export const TaxAccountantAreaBlockLocation = {schema, model};
export type ITaxAccountantAreaBlockLocationResModel = z.infer<typeof TaxAccountantAreaBlockLocation.model>;
export const DEFAULT_TAX_ACCOUNTANT_AREA_BLOCK_LOCATION_RES: ITaxAccountantAreaBlockLocationResModel = {
    list: {}
};
